var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinux(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 15,
    height: 15,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 8.954,
    y1: 20.386,
    x2: 11.771,
    y2: 41.233,
    gradientUnits: "userSpaceOnUse",
    id: "color-1_uJP6M6Qi3A6T_gr1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 23.74,
    y1: -10.617,
    x2: 32.123,
    y2: 51.404,
    gradientUnits: "userSpaceOnUse",
    id: "color-2_uJP6M6Qi3A6T_gr2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 14.144,
    y1: 4.638,
    x2: 28.714,
    y2: 61.753,
    gradientUnits: "userSpaceOnUse",
    id: "color-3_uJP6M6Qi3A6T_gr3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#585856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 12.496,
    y1: 16.013,
    x2: 12.496,
    y2: 18.965,
    gradientUnits: "userSpaceOnUse",
    id: "color-4_uJP6M6Qi3A6T_gr4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 26.814,
    y1: 21.585,
    x2: 29.469,
    y2: 41.228,
    gradientUnits: "userSpaceOnUse",
    id: "color-5_uJP6M6Qi3A6T_gr5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.499,30.607c-1.243,4.843 -1.83,5.853 -3.174,7.335c-1.067,1.176 -1.832,0.579 -2.153,-0.368c-0.609,-1.798 -0.278,-8.655 3.989,-12.699z",
    fill: "url(#color-1_uJP6M6Qi3A6T_gr1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,42h-9l-10.753,-34.919c1.745,-1.778 4.966,-3.081 8.753,-3.081c10,0 13,11.297 13,20.541v15.459c0,1.105 -0.895,2 -2,2z",
    fill: "url(#color-2_uJP6M6Qi3A6T_gr2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.247,7.081c-4.324,3.979 -5.247,11.298 -5.247,17.534v14.385c0,1.657 1.343,3 3,3h13c0,-7.159 2,-16.317 2,-23.476c0,-10.524 -6,-12.466 -12.753,-11.443z",
    fill: "url(#color-3_uJP6M6Qi3A6T_gr3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 15,
    r: 3,
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.54526,
    cy: 18.23852,
    transform: "rotate(-35.653)",
    rx: 1.345,
    ry: 0.906,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.388,17.519c1.753,-0.402 9.612,-1.519 9.612,-1.519c0.518,0.333 0.992,0.73 0.992,1.565c0,0.777 -0.451,1.124 -0.992,1.435c0,0 -7.826,-0.337 -9.574,-0.646c-0.553,-0.098 -0.568,-0.713 -0.038,-0.835z",
    fill: "url(#color-4_uJP6M6Qi3A6T_gr4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 15,
    r: 3,
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.67088,
    cy: 24.06627,
    transform: "rotate(-35.653)",
    rx: 1.345,
    ry: 0.906,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,19c0.413,-0.238 0.769,-0.499 0.917,-0.953l-6.708,0.646c2.733,0.249 5.791,0.307 5.791,0.307z",
    fill: "#e3a600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.801,26.068c-0.401,-0.534 -1.199,-0.538 -1.598,-0.003c-2.973,3.981 -6.953,9.45 -7.241,11.257c-0.25,1.569 0.538,1.678 1.538,1.678c0.986,0 8.295,0 9.455,-9.593c0.031,-0.257 -0.042,-0.523 -0.197,-0.73z",
    fill: "url(#color-5_uJP6M6Qi3A6T_gr5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinux);
export default __webpack_public_path__ + "static/media/linux.3027a8e55805408158e44cefad3f022b.svg";
export { ForwardRef as ReactComponent };